import cn from 'clsx';
import PAGE_TYPE from '@/constants/pageType';
import { getServerTranslation } from '@/i18n/index';
import MiniHome from '../../app/cms/common/uk-miniHome';
import styles from './index.module.scss';
import Category from './components/category';
import HeaderLogo from './components/headerLogo/headerLogo';
import LanguageLogo from './components/languageLogo';
import { Mental } from './components/mental/mental';
import { Search } from './components/search';
import HeaderSticky from './components/headerSticky/headerSticky';
import UserInfoButton from './components/userInfoButton/userInfoButton';
import BenefitBarWrap from './components/benefitBarWrap/BenefitBarWrap';
import { AddressButtonServer } from './components/addressButton/AddressButton';
import { JDIHeaderNewProps as BaseJDIHeaderNewProps } from '@/common-components-src/types/jdiHeaderNew';

interface JDIHeaderNewProps extends BaseJDIHeaderNewProps {
  isHeaderDisabled?: boolean;
}

const JDIHeaderNew = async ({
  pageType,
  searchParams,
  pageCode = '',
  isHeaderDisabled = false,
}: JDIHeaderNewProps) => {
  const { t } = await getServerTranslation();
  const keyword = searchParams?.k || '';
  const isHomeOrMiniHome = pageType === PAGE_TYPE.HOME || pageType === PAGE_TYPE.MINI_HOME;

  const getMainContainerStyle = () => {
    switch (pageType) {
      case PAGE_TYPE.ONLY_LOGO:
      case PAGE_TYPE.UNSUBSCRIBE:
        return { display: 'none' };
      default:
        return {};
    }
  };

  const unsubscribeTag = () => {
    if (pageType === PAGE_TYPE.UNSUBSCRIBE) {
      return <div className={styles.unsubscribeTxt}>{t('profile.unsubscribe.title')}</div>;
    }
  };

  return (
    <div
      id='sticky-header'
      className={cn(styles.header, {
        [styles.home]: isHomeOrMiniHome,
      })}
    >
      <div id='jdi-header' className={styles.jdiHeader}>
        <HeaderSticky />
        <BenefitBarWrap pageType={pageType} pageCode={pageCode} />
        <div className={styles.header}>
          <div className={styles.headerMainWrap}>
            <div className={styles.w}>
              <div
                className={styles.headerMain}
                style={isHeaderDisabled ? { pointerEvents: 'none' } : {}}
              >
                <HeaderLogo />
                <div
                  id='jdi-header-main-container'
                  style={getMainContainerStyle()}
                  className={cn(styles.mainContainer, {
                    [styles.headerDisabled]: isHeaderDisabled,
                  })}
                >
                  <Category pageType={pageType} isHeaderDisabled={isHeaderDisabled} />
                  <Search defaultKeyword={keyword as string} pageCode={pageCode} />
                  <AddressButtonServer />
                  <LanguageLogo />
                </div>
                <div
                  id='jdi-header-user-info'
                  className={styles.userInfo}
                  style={getMainContainerStyle()}
                >
                  <UserInfoButton disable={isHeaderDisabled} />
                </div>
                {unsubscribeTag()}
              </div>
            </div>
          </div>
          {isHomeOrMiniHome && <MiniHome />}
          {isHomeOrMiniHome && <Mental pageCode={pageCode} />}
        </div>
      </div>
    </div>
  );
};

export default JDIHeaderNew;
